import { getObjectTemplate, getWidgets } from '/src/features/object-templates/api/object-template.service';
import {
  getObjectDetails,
  getObjectFieldDetails,
  getTabularReferenceObjectFields
} from '/src/features/object-records/api/object-service';
import { fetchTableFields } from '/src/features/widgets/analyze/analyze-widget-service';
import { getExternalTemplate, getExternalTemplateWidgets } from '../../external-forms/api/external-forms.service';

import { widgetForState } from '/src/features/widgets/edit/widget-helper';

export const actions = {
  async getTemplate({ commit }, { templateUUID, params }) {
    if (params && params.tenantEntryUUID) {
      commit('setTemplate', await getExternalTemplate(templateUUID, params));
    } else {
      commit('setTemplate', await getObjectTemplate(templateUUID));
    }
  },
  async getTemplateWidgets({ commit }, { templateUUID, params }) {
    if (params && params.tenantEntryUUID) {
      let widgets = await getExternalTemplateWidgets(templateUUID, params.tenantEntryUUID);
      commit('setTemplateWidgets', {
        widgets: widgets.map((widget) => widgetForState(widget)),
        templateUUID
      });
    } else {
      commit('setTemplateWidgets', { widgets: await getWidgets(templateUUID), templateUUID });
    }
  },
  async getObjectFields({ commit }, objectUUID) {
    commit('setFields', { fields: await getObjectFieldDetails(objectUUID, { fetchUUID: true }), objectUUID });
  },
  async getDataLoaderDistinctField({ commit, state, dispatch }, distinctUUIDS) {
    commit('setIsDataLoaderLoading', true);
    const fieldListPromise = distinctUUIDS.map(
      (objectUUID) => state.objectFieldsMap[objectUUID] || dispatch('getObjectFields', objectUUID)
    );
    await Promise.all(fieldListPromise);
    commit('setIsDataLoaderLoading', false);
  },
  async getObjectDetails({ commit }, objectUUID) {
    commit('setObjectDetails', await getObjectDetails(objectUUID));
  },
  async getTabularReferenceObjectFields({ commit }, { tabularObjectUUID, objectUUID, fieldUUID }) {
    commit('setFields', {
      fields: await getTabularReferenceObjectFields(objectUUID, fieldUUID, { fetchUUID: true }),
      objectUUID: tabularObjectUUID
    });
  },
  async getDbTableFields({ commit }, tableName) {
    commit('setDbTableColumns', {
      tableName,
      columns: await fetchTableFields(tableName, true)
    });
  }
};
